import { render } from "./LeaveEntitlements.vue?vue&type=template&id=e3f62134"
import script from "./LeaveEntitlements.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__